import exchange from '../../../../../assets/images/financialSource/exchange.svg'
import fullFree from '../../../../../assets/images/financialSource/fullFree.svg'
import fullSubsidy from '../../../../../assets/images/financialSource/fullSubsidy.svg'
import partialSubsidy from '../../../../../assets/images/financialSource/partialSubsidy.svg'

export const mapPaymentTypes = {
  1: {
    id: 1,
    name: 'Полная дотация',
    imageSrc: fullSubsidy,
  },
  2: {
    id: 2,
    name: 'Частичная дотация',
    imageSrc: partialSubsidy,
  },
  3: {
    id: 3,
    name: 'За счет абонента',
    imageSrc: fullFree,
  },
  4: {
    id: 4,
    name: 'Не выбрана',
    imageSrc: null,
  },
  5: {
    id: 5,
    name: 'Обмен',
    imageSrc: exchange,
  },
}
